import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/like-forum'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  edit(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  add(like) {
    return http.post(`${resource}`, like)
  },
  update(like, uuid) {
    return http.put(`${resource}/${uuid}`, like)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
